export const parsePathAndMethod = (path: string): { method: 'GET' | 'POST' | 'PUT' | 'DELETE'; path: string } => {
    const [method, ...rest] = path.split(':');

    return {
        method: method as 'GET' | 'POST' | 'PUT' | 'DELETE',
        path: rest.join(':'),
    };
};
